import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import { SvgImage } from '../common';
import { Container } from '../helpers/Grid';
import FeaturedCompetitionsListProps from './type';
import { scrollIntoView } from '../../utilities/browser';
import './styles.scss';

const defaultCutOffIndex: number = 4;
const scrollToIdRef: string = '#featured-competitions-list-item-';

const FeaturedCompetitionsList = ({
  links,
  discipline,
  viewMoreLabel,
}: FeaturedCompetitionsListProps) => {
  const linksContainer = useRef<HTMLUListElement>(null);
  const [cutOffIndex, setCutOffIndex] = useState<number>(defaultCutOffIndex);
  const [nextScrollToId, setNextScrollToId] = useState<number>(defaultCutOffIndex + 1);
  const [isViewMore, setIsViewmore] = useState<boolean>(
    (links.length - 1) >= cutOffIndex,
  );

  const viewMoreAction = (event: React.MouseEvent) => {
    event.preventDefault();
    if (links.length > cutOffIndex) {
      setCutOffIndex(cutOffIndex + defaultCutOffIndex);
    }
  };

  useEffect(() => {
    setIsViewmore((links.length - 1) >= cutOffIndex);
    // we add x2 to the cutOffIndex this accounts for the
    // index offset and the next element.
    setNextScrollToId(cutOffIndex);
    if (linksContainer.current) {
      const scrollToElement = linksContainer.current.querySelector(
        `${scrollToIdRef}${nextScrollToId}`,
      );

      if (scrollToElement) {
        scrollIntoView((scrollToElement as HTMLElement), 'smooth');
      }
    }
  }, [cutOffIndex]);

  return (
    <div className={`featured-competitions-list featured-competitions-list--${discipline}`}>
      <Container>
        <div className="featured-competitions-list__inner">
          <ul className="featured-competitions-list__links" ref={linksContainer}>
            {links.slice(0, cutOffIndex).map((link, index) => (
              <li key={`featured-competitions-list-item-${link.url}`} id={`featured-competitions-list-item-${index}`}>
                <a className="featured-competitions-list__link" href={link.url} title={link.title}>
                  {link.title}
                  <SvgImage title="arrow" reference="#icon-think-arrow" />
                </a>
              </li>
            ))}
          </ul>
          {isViewMore && (
            <div className="featured-competitions-list__view-more">
              <a className="link link--has-icon false false" href="#" onClick={(event: React.MouseEvent) => viewMoreAction(event)}>
                <div className="link__icon">
                  <SvgImage title="arrow" reference="#icon-think-arrow" />
                </div>
                <span>{viewMoreLabel}</span>
              </a>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default FeaturedCompetitionsList;
